import { Button, TextField } from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import { useSaveDeliveryNoteMutation } from "state/api";

const DeliveryNote = ({ data, setLoader }) => {
  const [saveDeliveryNote] = useSaveDeliveryNoteMutation();

  const formik = useFormik({
    initialValues: {
      deliveryDate:
        new Date().toISOString().slice(0, 11) +
        new Date().toLocaleTimeString().slice(0, 5),
    },
    onSubmit: (values) => {
      values.transactionId = data._id;
      setLoader(true);
      saveDeliveryNote(values)
        .unwrap()
        .then((res) => {
          alert("Delivery Note Saved");
          setLoader(false);
          window.location.reload();
        })
        .catch((err) => {
          alert("Delivery Note Failed");
          setLoader(false);
        });
    },
  });

  return (
    <>
      <div className="my-2 text-lg font-bold text-gray-700">Delivery Note</div>

      <form onSubmit={formik.handleSubmit}>
        <div className="mt-4 grid grid-cols-2 gap-4">
          <TextField
            id="deliveryDate"
            name="deliveryDate"
            label="Delivery Date Time"
            type="datetime-local"
            value={formik.values.deliveryDate}
            onChange={formik.handleChange}
            fullWidth
          />

          <Button
            type="submit"
            className="my-2 bg-slate-600 hover:bg-slate-700 text-white w-24"
          >
            Submit
          </Button>
        </div>
      </form>
    </>
  );
};
export default DeliveryNote;
